import {Mapper} from '@s-ui/domain'

import {DEFAULT_CULTURE, TIMEZONE_BY_CULTURE} from '../../config/base.js'

export class FromSpecsListRawDataToSpecsListValueObjectMapper extends Mapper {
  constructor({specsListValueObjectFactory, specsValueObjectFactory}) {
    super()
    this._specsListValueObjectFactory = specsListValueObjectFactory
    this._specsValueObjectFactory = specsValueObjectFactory
  }

  setParams({nextField}) {
    this._nextField = nextField
    return this
  }

  // Fixed culture and zone: the server default (en-US, UTC) printed US dates and could shift the day
  _parseDate = date =>
    new Date(date).toLocaleDateString(DEFAULT_CULTURE, {timeZone: TIMEZONE_BY_CULTURE[DEFAULT_CULTURE]})

  _parseImages = images => images.map(image => image.url)

  _parseVehicleField = ({start, end, vehicleId, sortedImages}) => {
    return this._specsValueObjectFactory({
      value: vehicleId,
      ...(sortedImages && {images: this._parseImages(sortedImages)}),
      customText: {
        init: {text: 'COMMON_FROM_DATE', params: this._parseDate(start)},
        ...(end && {
          end: {
            text: 'COMMON_TO_DATE',
            params: end && this._parseDate(end)
          }
        })
      }
    })
  }

  _parseTrimLevelField = ({description, manufacturerPrice, id, name, sortedImages}) => {
    return this._specsValueObjectFactory({
      value: id,
      text: name,
      ...(sortedImages && {images: this._parseImages(sortedImages)}),
      customText: {
        description,
        manufacturerPrice
      }
    })
  }

  _parseFuelTypeField = ({fuelTypeId, name, sortedImages}) => {
    return this._specsValueObjectFactory({
      value: fuelTypeId,
      text: name,
      ...(sortedImages && {images: this._parseImages(sortedImages)})
    })
  }

  _parseColorField = ({id, label, hexCode, price, sortedImages}) => {
    return this._specsValueObjectFactory({
      value: id,
      text: label,
      ...(sortedImages && {images: this._parseImages(sortedImages)}),
      customText: {
        hexCode,
        price: parseFloat(price)
      }
    })
  }

  _parseVersionsField = ({
    bodyTypeId,
    consumption,
    electricFeatures,
    hp,
    manufacturerPrice,
    transmissionType,
    transmissionTypeId,
    version,
    vehicleId,
    sortedImages
  }) => {
    const hasConsumption = Boolean(consumption)
    const hasElectricFeatures = Boolean(electricFeatures)

    return this._specsValueObjectFactory({
      value: vehicleId,
      text: version,
      ...(sortedImages && {images: this._parseImages(sortedImages)}),
      customText: {
        bodyTypeId,
        ...(hasConsumption && {consumption}),
        ...(hasElectricFeatures && {electricFeatures}),
        hp,
        manufacturerPrice,
        transmissionType,
        transmissionTypeId
      }
    })
  }

  map = ({items}) => {
    const itemsVO = items.map(item => {
      if (this._nextField === 'engines') return this._parseVersionsField(item)
      if (item.vehicleId) return this._parseVehicleField(item)
      if (this._nextField === 'trimlevels') return this._parseTrimLevelField(item)
      if (this._nextField === 'fuel-types') return this._parseFuelTypeField(item)
      if (this._nextField === 'color') return this._parseColorField(item)

      const text = item?.name
      const values = Object.values(item)
      const {0: value} = values.filter(value => value !== text)

      return this._specsValueObjectFactory({
        text: text || item,
        value: text ? value : item
      })
    })

    return this._specsListValueObjectFactory({items: itemsVO})
  }
}
